export default __webpack_public_path__ + "static/skeleton_tank_scaled-07fe6735d077b07360f46b907c07bbc6.gif";